import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useMainStore } from "_hooks";

const AppRedirect = (props) => {
  const { to, isTestingOnly = false } = props;
  const { setRedirectPath } = useMainStore();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isTestingOnly) {
      setRedirectPath(pathname);
    }
  }, [setRedirectPath, pathname, isTestingOnly]);

  return <Navigate to={to} replace={true} />;
};

AppRedirect.propTypes = {
  to: PropTypes.string.isRequired,
  isTestingOnly: PropTypes.bool,
};

export default AppRedirect;
